import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  DialogPanel as HeadlessDialogPanel,
  TransitionChild,
} from "@headlessui/vue";
import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { ProvideDialog } from "./Dialog.vue";
import { inject, useAttrs, computed } from "vue";

interface PanelProps extends ExtractProps<typeof HeadlessDialogPanel> {
  as?: string | object;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Panel',
  props: {
    as: { default: "div" }
  },
  setup(__props: any) {

const { as } = __props as { as: string | object }



const dialog = inject<ProvideDialog>("dialog");

const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    "w-[90%] mx-auto bg-white relative rounded-md shadow-md transition-transform dark:bg-darkmode-600",
    dialog?.size == "md" && "sm:w-[460px]",
    dialog?.size == "sm" && "sm:w-[300px]",
    dialog?.size == "lg" && "sm:w-[600px]",
    dialog?.size == "xl" && "sm:w-[600px] lg:w-[900px]",
    dialog?.zoom.value && "scale-105",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionChild), {
      as: "div",
      enter: "ease-in-out duration-500",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "ease-in-out duration-[400ms]",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0",
      class: "fixed inset-0 bg-black/60",
      "aria-hidden": "true"
    }),
    _createVNode(_unref(TransitionChild), {
      as: "div",
      enter: "ease-in-out duration-500",
      enterFrom: "opacity-0 -mt-16",
      enterTo: "opacity-100 mt-16",
      entered: "opacity-100 mt-16",
      leave: "ease-in-out duration-[400ms]",
      leaveFrom: "opacity-100 mt-16",
      leaveTo: "opacity-0 -mt-16",
      class: "fixed inset-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(HeadlessDialogPanel), { as: "template" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(as), _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 16, ["class"]))
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 64))
}
}

})